import { Actions } from "csi/def/Actions";
import { ButtonEnum } from "designSystem/types/button-types";
import Controller from "csi/action/Controller";
import declare from "dojo/_base/declare";
import html from "csi/html";
import { View } from "csi/def/View";

const RefreshLabelItemsToolbarController = declare(Controller, {
	/**
	 * @override
	 * Change "Save" button to "Run" button.
	 */
	addProxyActions(defView: View, defActions: Actions) {
		defActions.addAction(this.getProxyAction(ButtonEnum.BUTTON_RUN, true, {
			m_class: html.CSS_BUTTON_PRIMARY,
		}));
		this.inherited(arguments);
	},
});

export = RefreshLabelItemsToolbarController;